/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mDanmaku.vue?vue&type=template&id=12970dba&scoped=true"
import script from "./mDanmaku.vue?vue&type=script&lang=js"
export * from "./mDanmaku.vue?vue&type=script&lang=js"
import style0 from "./mDanmaku.vue?vue&type=style&index=0&id=12970dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12970dba",
  null
  
)

export default component.exports